import React, { useContext, useState } from 'react';
import { StyleSheet, TouchableHighlight, View } from 'react-native';
import DyteText from './DyteText';
import { downloadFile, getExtension, getFileSize } from '../utils/file';
import { SvgXml } from 'react-native-svg';
import { defaultIconPack, IconPack } from '../lib/icons';
import { Message, FileMessage } from '@dytesdk/web-core';
import DyteSpinner from './DyteSpinner';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  message,
  // ToDo: Figure out if we need this
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isContinued,
  // ToDo: Figure out if we need this
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  now,
  iconPack = defaultIconPack,
}: {
  message: Message;
  isContinued?: boolean;
  now?: Date;
  iconPack?: IconPack;
}) {
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  iconPack = iconPack ?? defaultIconPack;
  const [downloading, setDownloading] = useState(false);
  const _downloadFile = async () => {
    downloadFile((message as FileMessage).link, {
      name: (message as FileMessage).name,
      fallbackName:
        'DyteChatFile.' + getExtension((message as FileMessage).name),
    }).then(() => setDownloading(false));
    setDownloading(true);
  };
  const styles = StyleSheet.create({
    textContainer: {
      justifyContent: 'center',
    },
    fileContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: 8,
      borderRadius: 4,
      backgroundColor: colors.background[800],
    },
    downloadIcon: {
      alignItems: 'center',
      justifyContent: 'center',
      padding: 8,
      borderRadius: 8,
      marginLeft: 8,
      backgroundColor: colors.background[700],
    },
    text: {
      opacity: 0.8,
    },
    fileName: {
      marginBottom: 4,
    },
    fileSize: {
      flexDirection: 'row',
      justifyContent: 'space-around',
    },
  });
  return (
    <View style={styles.fileContainer}>
      <View>
        <DyteText style={styles.fileName}>
          {message !== undefined ? (message as FileMessage).name : 'File Name'}
        </DyteText>
        <View style={styles.fileSize}>
          <DyteText size="sm" style={styles.text}>{`${getExtension(
            (message as FileMessage).name
          ).toUpperCase()} | `}</DyteText>
          <DyteText size="sm" style={styles.text}>{`${getFileSize(
            (message as FileMessage).size
          )}`}</DyteText>
        </View>
      </View>
      {/* Todo: Add download logic here */}
      <TouchableHighlight
        underlayColor={colors.background[800]}
        style={styles.downloadIcon}
        onPress={_downloadFile}
      >
        <>
          {downloading && (
            <View style={styles.textContainer}>
              <DyteSpinner />
            </View>
          )}
          {!downloading && (
            <SvgXml
              xml={iconPack.download.replace('currentColor', colors.text)}
              height={20}
              width={20}
            />
          )}
        </>
      </TouchableHighlight>
    </View>
  );
}
